import { Close } from "@mui/icons-material";
import { Button, Checkbox, Divider, FormControl, IconButton, Input, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Paper, Typography } from "@mui/material";
import { makeStyles, useTheme } from "@mui/styles";
import { useState } from "react";
import { getRTFOCompanyName } from "./rtfoConfig";

const useStyles = makeStyles(theme => ({
  root: {
    position: 'absolute',
    left: 320,
    top: 0,
    width: 300,
    height: '100vh',
    overflowY: 'auto',
    // padding: 10,
    // paddingTop: 80,
    zIndex: 1111,
    borderRadius: 0,
    paddingBottom: 80
  },
  heading: {
    marginBottom: 20,
    fontSize: 18
  },
  header: {
    display: 'flex', 
    justifyContent: 'space-between', 
    alignItems: 'center', 
    position: 'fixed', 
    top: 50, 
    width: 300, 
    height: 50,
    padding: 10,
    borderBottom: '1px solid lightgrey',
    zIndex: 70
  },
  footer: {
    display: 'flex',
    justifyContent: 'center', 
    alignItems: 'center', 
    position: 'fixed',
    paddingTop: 30,
    paddingBottom: 30,
    bottom: 0, 
    width: 300, 
    height: 40,
    borderTop: '1px solid lightgrey',
  }
}));

export const RTFOPadsListFilter = ({ padActivity, filters, setFilters, setPadsListFilterVisible, setCurrentPadName, darkMode }) => {

  const classes = useStyles();
  const theme = useTheme();

  const [dateFrom, setDateFrom] = useState(filters?.dateFrom ? filters?.dateFrom : "");
  const [dateTo, setDateTo] = useState(filters?.dateTo ? filters?.dateTo : "");
  const [statusFilter, setStatusFilter] = useState(filters?.status ? filters?.status : []);
  const [formationFilter, setFormationFilter] = useState(filters?.formation ? filters.formation : []);
  const [areaFilter, setAreaFilter] = useState(filters?.area ? filters.area : []);
  const [clientFilter, setClientFilter] = useState(filters?.client ? filters?.client : []);

  const customList = (state, setState, items) => (
    <List
      dense
      component="div"
      role="list"
    >
      {items?.length > 0 && items.map((item, i) => {
        return (
          <ListItemButton
            key={item.value}
            role="listitem"
            onClick={e => handleCheckToggle(item.value, setState)}
            style={{display: 'flex', flexDirection: 'row'}}
          >
            <ListItemIcon>
              <Checkbox
                checked={state.includes(item.value)}
                tabIndex={-1}
                disableRipple
                color="primary"
                style={{margin: 0}}
              />
            </ListItemIcon>
            <ListItemText primary={`${item.value}`} secondary={`(${item.count})`} secondaryTypographyProps={{style: {marginLeft: 5}}} style={{fontSize: 10, display: 'flex', flexDirection: 'row'}} />
          </ListItemButton>
        );
      })}
      <ListItem />
    </List>
  );

  function handleCheckToggle(value, setValue) {
    setValue(prev => prev.includes(value) ? prev.filter(f => f !== value) : [...prev, value])
  };

  return (
    <Paper elevation={0} className={classes.root} style={{backgroundColor: theme?.palette?.elevationOne?.[darkMode ? 'dark' : 'light']}}>
      <div className={classes.header}>
        <Typography>FILTERS</Typography>
        <IconButton onClick={() => setPadsListFilterVisible(false)}><Close /></IconButton>
      </div>
      <Divider style={{width: '100%'}} />

      <div style={{position: 'absolute', width: '100%', top: 50, bottom: 110, overflowY: 'auto', padding: '0px 10px 0px 10px' }}>

        <Typography color='textSecondary' style={{fontSize: 12, marginTop: 20}}>DATE CREATED (FROM)</Typography>
        <FormControl variant="filled" style={{width: '100%'}}>
          <Input type="date" value={dateFrom} onChange={e => setDateFrom(e.target.value)} />
        </FormControl>


        <Typography color='textSecondary' style={{fontSize: 12, marginTop: 20}}>DATE CREATED (TO)</Typography>
        <FormControl variant="filled" style={{width: '100%'}}>
          <Input type="date" value={dateTo} onChange={e => setDateTo(e.target.value)} />
        </FormControl>

        <Divider style={{width: '100%', margin: '10px 0px'}} />

        <Typography color='textSecondary' style={{fontSize: 12, marginTop: 10}}>STATUS</Typography>
        {customList(statusFilter, setStatusFilter, getParameterValues('status'))}

        <Divider style={{width: '100%', margin: '10px 0px'}} />

        <Typography color='textSecondary' style={{fontSize: 12, marginTop: 10}}>FORMATION</Typography>
        {customList(formationFilter, setFormationFilter, getParameterValues('formation'))}

        <Divider style={{width: '100%', margin: '10px 0px'}} />

        <Typography color='textSecondary' style={{fontSize: 12, marginTop: 10}}>AREA</Typography>
        {customList(areaFilter, setAreaFilter, getParameterValues('area'))}

        <Divider style={{width: '100%', margin: '10px 0px'}} />

        <Typography color='textSecondary' style={{fontSize: 12, marginTop: 10}}>COMPANY</Typography>
        {customList(clientFilter, setClientFilter, getParameterValues('client'))}

        <Divider style={{width: '100%', margin: '10px 0px'}} />

      </div>

      <div className={classes.footer}>
        <Button 
          variant="outlined" 
          color="primary" 
          style={{
            marginRight: 20,
            color: (darkMode ? '#fff' : theme.palette.primary.main), 
            borderColor: (darkMode ? '#fff' : theme.palette.primary.main)
          }} 
          onClick={clearFilters}
        >
          Clear
        </Button>
        <Button 
          variant="contained" 
          color="primary" 
          style={{
            marginLeft: 20,
            color: darkMode ? '#000' : '#fff', 
            backgroundColor: darkMode ? "#fff" : theme.palette.primary.main
          }} 
          onClick={applyFilters}
        >
          Apply
        </Button>
      </div>

    </Paper>
  );

  function applyFilters() {
    const filters = {};
    if (dateFrom?.length > 0) filters.dateFrom = dateFrom;
    if (dateTo?.length > 0) filters.dateTo = dateTo;
    if (statusFilter?.length > 0) filters.status = statusFilter;
    if (formationFilter?.length > 0) filters.formation = formationFilter;
    if (areaFilter?.length > 0) filters.area = areaFilter;
    if (clientFilter?.length > 0) filters.client = clientFilter;

    setFilters(filters);
  };

  function clearFilters() {
    setDateFrom("");
    setDateTo("");
    setStatusFilter([]);
    setFormationFilter([]);
    setAreaFilter([]);
    setClientFilter([]);
    setFilters({});
    setCurrentPadName("");
  };


  function getParameterValues(param) {
    
    switch(param) {
      case 'status': {
        const paramValues = [];

        const values = [...new Set(padActivity.map(pad => pad.isActive ? true : false))];

        values.forEach(value => {
          const count = padActivity.filter(pad => pad.isActive === value)?.length;
          const formattedValue = value ? 'Active' : 'Completed';
          paramValues.push({value: formattedValue, count});
        })
        return paramValues
      }
      case 'formation': {
        const paramValues = [];

        const values = [...new Set(padActivity.map(pad => pad.formation))];

        values.forEach(value => {
          const count = padActivity.filter(pad => pad.formation === value)?.length;
          paramValues.push({value, count});
        })
        return paramValues
      }
      case 'area': {
        const paramValues = [];

        const values = [...new Set(padActivity.map(pad => pad.area))];

        values.forEach(value => {
          const count = padActivity.filter(pad => pad.area === value)?.length;
          paramValues.push({value, count});
        })
        return paramValues
      }
      case 'client': {
        const paramValues = [];

        const values = [...new Set(padActivity.map(pad => pad.client))];

        values.forEach(value => {
          const count = padActivity.filter(pad => pad.client === value)?.length;
          paramValues.push({value: getRTFOCompanyName(value), count});
        })
        return paramValues
      }
      default:
        return {}
    }
  }
}